import { ITableForm } from '../../common/interfaces/table.interface';

export enum CellType {
    SingleTextLine = 'singleTextLine',
    Checkbox = 'checkbox',
    Person = 'person',
    DateAndTime = 'dateAndTime',
    Label = 'label',
    Menu = 'menu',
    Icon = 'icon',
    RangeBlocks = 'rangeBlocks',
    IconButton = 'iconButton',
    Tags = 'tags',
}

export enum SortType {
    lexical = 'lexical',
    numeric = 'numeric',
    chronological = 'chronological',
    boolean = 'boolean',
}

export enum SIDES {
    LEFT = 'left',
    RIGHT = 'right',
}

export enum FilterTypes {
    options = 'options',
    score_range = 'score_range',
    number_range = 'number_range',
    datepicker_range = 'datepicker_range',
    boolean = 'boolean',
    tags = 'tags',
}

export enum SortDirections {
    asc = 'asc',
    desc = 'desc',
}

export const emptyTableForm = (
    tableId: string,
    defaultSort?: string
): ITableForm => {
    return {
        filters: [],
        search: '',
        selectedRows: {},
        sort: { sortKey: defaultSort || 'id', sortDirection: 'desc' },
        tableId: tableId,
        toggles: {},
    };
};

export enum MenuActionIds {
    Publish = 'publish',
    Edit = 'edit',
    Resume = 'resume',
    Suspend = 'suspend',
    Clone = 'clone',
    Cancel = 'cancel',
    Complete = 'complete',
    Reject = 'reject',
    Transfer = 'transfer',
    Withdraw = 'withdraw',
    Delete = 'delete',
    ResendInvite = 'resendInvite',
}
